// extracted by mini-css-extract-plugin
module.exports = {"root":"message_root__uZRMe","root_error":"message_root_error__3qlss"};